<app-loader [class.show]="loaderSvc.enabled | async"></app-loader>
<router-outlet></router-outlet>
